import type { PathConfigMap } from "@react-navigation/native";

import { authV2NavConfig } from "../auth-v2/nav-config";
import { SCREENS } from "../screens";
import type { RootStackParamList } from "./types";

const {
  AuthStack,
  ResetPassword,
  SetPassword,
  ConfirmEmail,
  CaregiverPDF,
  Unsubscribe,
} = SCREENS;

/**
 * Everything the root stack serves outside the signed-in app stack: the
 * sign-in stack itself, and the screens a link opens without a session. The
 * root navigator mounts the app stack only for a signed-in family, so these
 * are the routes that have no signed-in counterpart here.
 *
 * Kept apart from rootNavConfig, which spreads it, so that the cut-over gate
 * can ask which routes are pre-login without pulling in the app stack.
 */
export const preLoginNavScreens: PathConfigMap<RootStackParamList> = {
  [AuthStack.name]: authV2NavConfig,
  [ResetPassword.name]: ResetPassword.path,
  [SetPassword.name]: SetPassword.path,
  [ConfirmEmail.name]: ConfirmEmail.path,
  [CaregiverPDF.name]: CaregiverPDF.path,
  [Unsubscribe.name]: Unsubscribe.path,
};
